const poll = async (fn, validate, interval = 10000, maxAttempts=6) => {
    // console.log('Starting to poll...');
    var attempts = 0;

    const executePoll = async (resolve, reject) => {
        try {
            // console.count('Polling');
            const result = await fn();
            attempts++;
            if (validate(result)) {
                return resolve(result);
            }
            else if (maxAttempts && attempts === maxAttempts) {
              return reject(new Error('Exceeded max attempts'))
            }
            else {
                setTimeout(executePoll, interval, resolve, reject);
            }
        } catch (error) {
            reject(error);
        }
    };

    return new Promise(executePoll);
};

export default poll;
